<template>
  <ImageViewer v-if="showImage" @closeImage="handleImageClick('')" :image="popupImage" />
  <div class="gallery">
    <div class="container mx-auto lg:py-16 py-10 px-3 flex flex-col lg:gap-5 gap-2 justify-center">
      <div class="text-center font-primary font-semibold text-xl text-primary">Our Recent Works</div>
      <div class=" text-center font-bold lg:text-4xl text-2xl font-primary ">Project Gallery</div>
      <div class="grid grid-row-2 gap-5 py-5 lg:mt-5">
        <div class="grid md:grid-cols-2 grid-cols-1 gap-5">
          <img :src="image_1" class="w-full h-[250px] hover:cursor-pointer" @click="handleImageClick(image_1)"
            alt="img" />
          <img :src="image_2" class="w-full h-[250px] hover:cursor-pointer" @click="handleImageClick(image_2)"
            alt="img" />
        </div>
        <div class="grid md:grid-cols-3 grid-cols-1 gap-5">
          <img :src="image_3" class="w-full h-[250px] hover:cursor-pointer" @click="handleImageClick(image_3)"
            alt="img" />
          <img :src="image_4" class="w-full h-[250px] hover:cursor-pointer" @click="handleImageClick(image_4)"
            alt="img" />
          <img :src="image_5" class="w-full h-[250px] hover:cursor-pointer" @click="handleImageClick(image_5)"
            alt="img" />
        </div>
        <div class="grid md:grid-cols-2 grid-cols-1 gap-5">
          <img :src="image_6" class="w-full h-[250px] hover:cursor-pointer" @click="handleImageClick(image_6)"
            alt="img" />
          <img :src="image_7" class="w-full h-[250px] hover:cursor-pointer" @click="handleImageClick(image_7)"
            alt="img" />
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { ref } from "vue";
import ImageViewer from "../Global/ImageViewer.vue";
const image_1 = require("../../assets/v-1.1/about-service.png");
const image_2 = require("../../assets/v-1.1/water-service.png");
const image_3 = require("../../assets/v-1.1/legal-base.png");
const image_4 = require("../../assets/v-1.1/about-us-heating.webp");
const image_5 = require("../../assets/v-1.1/about-us-plumbing.webp");
const image_6 = require("../../assets/v-1.1/ServicesdetailImages/Fire-sprinkler/header-image-1.webp");
const image_7= require("../../assets/v-1.1/ServicesdetailImages/Drain-sewer/section-01.webp");




const popupImage = ref(image_1);
const showImage = ref(false);
const handleImageClick = (image) => {
  popupImage.value = image;
  showImage.value = !showImage.value;
};
</script>
<style scoped>
.gallery {
  background-image: url("../../assets/v-1.1/recent-work-banner.png");
  background-position: top left;
  background-size: cover;
  background-repeat: no-repeat;
}
</style>
